import { MAX_NAME_LENGTH } from '@miyuki/domain';
import { Button, Input, Label, Sheet, SheetContent, SheetHeader, SheetTitle } from '@miyuki/ui';
import * as React from 'react';

import { t } from '@/lib/i18n';

/** Nombre con el que se guarda el diseño (RF-33). */
export interface SaveDesignSheetProps {
  readonly open: boolean;
  readonly initialName: string;
  readonly onSave: (name: string) => void;
  readonly onClose: () => void;
}

/**
 * El nombre se reinicia al abrir mediante `key`, que remonta el panel: es lo
 * que React recomienda en vez de sincronizar estado con un efecto.
 */
export function SaveDesignSheet(props: SaveDesignSheetProps) {
  return <SaveDesignForm key={props.open ? props.initialName : 'closed'} {...props} />;
}

function SaveDesignForm({ open, initialName, onSave, onClose }: SaveDesignSheetProps) {
  const [name, setName] = React.useState(initialName);

  const trimmed = name.trim();
  const valid = trimmed.length > 0 && trimmed.length <= MAX_NAME_LENGTH;

  return (
    <Sheet
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <SheetContent side="bottom" className="pb-8">
        <SheetHeader>
          <SheetTitle>{t('save')}</SheetTitle>
        </SheetHeader>

        <div className="flex flex-col gap-3 px-4 pb-2">
          <Label htmlFor="design-name">{t('designName')}</Label>
          <Input
            id="design-name"
            className="h-11"
            maxLength={MAX_NAME_LENGTH}
            value={name}
            aria-invalid={!valid}
            onChange={(event) => {
              setName(event.target.value);
            }}
          />
          <Button
            size="touch"
            disabled={!valid}
            onClick={() => {
              onSave(trimmed);
            }}
          >
            {t('save')}
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
